<!-- <cx-page-slot id="account-nav" position="HeaderLinks"></cx-page-slot> -->

<div style="min-height: 50vh">
  @if (quoteId) {
    <div>
      <quotes-history-details></quotes-history-details>
    </div>
  } @else {
    <div><quotes-history-form></quotes-history-form></div>
  }

</div>
